<template>

    <router-view></router-view>

</template>


<script>
export default {
  name: "NewsModule",
  components: {},
  data: () => ({}),
};
</script>
